import { createSelector } from 'reselect';
import { getRefundPassengerLabel } from '../../lib/refundPassengerUtils';
import { AnyStateWithRefund, RefundPassengerDocument } from '../types';
import { getSelectedRefundFamilies } from '../passengers/selectors';
import { getSelectedReasonDocument } from '../selectedReason/selectors';

export const getDocumentsState = (state: AnyStateWithRefund) => state.refund.documents;

export const getIsAllDocumentSelected = createSelector(getDocumentsState, documentsState =>
	Object.values(documentsState).every(files => !!files?.filter(file => !file.error?.length)?.length)
);

export const getPassengersDocuments = createSelector(
	getDocumentsState,
	getSelectedRefundFamilies,
	getSelectedReasonDocument,
	(documentsState, selectedPassengers, selectedReasonDocument) => {
		const documents: RefundPassengerDocument[] = [];

		if (selectedReasonDocument) {
			selectedPassengers.forEach(passenger => {
				documents.push({
					passengerId: passenger.id,
					passengerFullName: getRefundPassengerLabel(passenger),
					documentType: selectedReasonDocument,
					files: documentsState[passenger.id]
				});
			});
		}

		return documents;
	}
);
